import { apiGet, apiPost, apiPut, apiDelete } from '@/services/api/apiClient';

export interface Company {
  _id: string;
  name: string;
  gst: string;
  address1: string;
  address2?: string;
  city: string;
  state: string;
  pincode: string;
  mobile: string;
  email: string;
  isActive: boolean;
  isDeleted: boolean;
  remarks?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CompanyFormData {
  name: string;
  gst: string;
  address1: string;
  address2?: string;
  city: string;
  state: string;
  pincode: string;
  mobile: string;
  email: string;
  isActive: boolean;
  remarks?: string;
}

export interface CompanyListParams {
  page?: number;
  limit?: number;
  search?: string;
  isActive?: boolean;
}

export interface CompanyListResponse {
  success: boolean;
  message: string;
  data: {
    companies: Company[];
    pagination: {
      currentPage: number;
      totalPages: number;
      totalItems: number;
      itemsPerPage: number;
    };
  };
}

export interface CompanyResponse {
  success: boolean;
  message: string;
  data: Company;
}

class CompanyService {
  private baseUrl = '/companies';

  async getCompanies(params: CompanyListParams = {}): Promise<CompanyListResponse> {
    const queryParams = new URLSearchParams();
    
    if (params.page) queryParams.append('page', params.page.toString());
    if (params.limit) queryParams.append('limit', params.limit.toString());
    if (params.search) queryParams.append('search', params.search);
    if (params.isActive !== undefined) queryParams.append('isActive', params.isActive.toString());

    const url = `${this.baseUrl}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    return apiGet<CompanyListResponse>(url);
  }

  async createCompany(data: CompanyFormData): Promise<CompanyResponse> {
    return apiPost<CompanyResponse>(this.baseUrl, data);
  }

  async updateCompany(id: string, data: CompanyFormData): Promise<CompanyResponse> {
    return apiPut<CompanyResponse>(`${this.baseUrl}/${id}`, data);
  }

  async deleteCompany(id: string): Promise<{ success: boolean; message: string }> {
    return apiDelete<{ success: boolean; message: string }>(`${this.baseUrl}/${id}`);
  }

  async getCompanyById(id: string): Promise<CompanyResponse> {
    return apiGet<CompanyResponse>(`${this.baseUrl}/${id}`);
  }
}

export const companyService = new CompanyService();